import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains, nullsafe, toObservable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Value {
    IdDireccionOrigen?: number | null;
    IdContactoOrigen?: number | null;
    IdSucursalOrigen?: number | null;
    TelefonoCliente?: string | null;
}

export interface Props {
    value: Value;
    onChange: (x: Value) => void;
    /**En caso de que el usuario puede seleccionar solo a este cliente origen, es el cliente origen */
    idClienteUsuario?: number;
    /**En caso de que el cliente pueda seleccionar solo direcciones dentro de su sucursal */
    idSucursalUsuario?: number;
    /**En caso de que el usuario pueda seleccionar sólo esa sucursal */
    idDireccionUsuario: number | undefined;
    /**Si tiene permiso de documentar cualquier origen no se debe de filtrar las direcciones */
    documentarCualquierOrigen: boolean;
}


export class OrigenSucursal extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    idContacto = (props: Props) => props.value.IdContactoOrigen;
    contacto = createSelectorRx(this.idContacto, id => toObservable(nullsafe(id, id => observeResource(resources.ContactoCliente.Get, id))));
    idDireccion = createSelectorRx(this.contacto, x => nullsafe(x, x => x.IdDireccionCliente));
    filtroSucursal = createSelectorRx(this.idDireccion, id => ({ IdDireccionCliente: id }));

    idClienteUsuario = (props: Props) => props.idClienteUsuario;
    idSucursal = (props: Props) => props.idSucursalUsuario;
    /**Si tiene permiso de documentar cualquier origen no se debe de filtrar las direcciones */
    filtrarDireccionesPermiso = (props: Props) => props.documentarCualquierOrigen;
    seDebeFiltrar = (props: Props) => !props.documentarCualquierOrigen;


    filtroCliente = createSelectorRx(this.idClienteUsuario, idCliente => ({
        IdRegistro: idCliente
    } as models.FiltroCliente));

    get rules(): validation.Rules<Value> {
        return {
            IdContactoOrigen: validation.required,
            IdSucursalOrigen: validation.required
        };
    }

    onChangeContacto = async (telefono: string | undefined, idContactoOrigen: number) => {
        if (telefono === undefined || telefono === null) { telefono = ""; }
        this.props.onChange({ ... this.props.value, IdContactoOrigen: idContactoOrigen });
    }

    onDireccionChange = async (idDireccion: number | null | undefined) => {
        let current = this.props.value;
        if (idDireccion == null) {
            current = { ...current, IdSucursalOrigen: undefined, IdDireccionOrigen: idDireccion };
            this.props.onChange(current);
            return;
        }

        current = { ...current, IdDireccionOrigen: idDireccion };

        this.props.onChange(current);
        let direccion = await resources.DireccionCliente.ObtenerDireccion(idDireccion);

        //Primero actualizamos el idDireccionDestino
        current = { ...current, TelefonoCliente: direccion.Direccion.Telefono };
        this.props.onChange(current);

        const sucursales = await resources.Sucursal.query({ IdDireccionCliente: idDireccion });
        const idSucursales = sucursales.map(x => x.IdRegistro);
        if (!contains(idSucursales, this.props.value.IdSucursalOrigen)) {
            current = { ...current, IdSucursalOrigen: first(idSucursales) };
            this.props.onChange(current);
        }
    }

    onSucursalChange = async (idSucursal: number) => {
        this.props.onChange({ ... this.props.value, IdSucursalOrigen: idSucursal });
    }

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Direccion = getField(selectores.DireccionClienteSelector);
        const Sucursal = getField(selectores.Sucursal);
        const Text = getField(kea.Text);
        const filtroCliente = this.filtroCliente(this.props);
        return [
            <Direccion key={1} field="IdDireccionOrigen" label="Origen" onChange={this.onDireccionChange}
                filtroCliente={filtroCliente}
                idDireccionUsuario={this.props.idDireccionUsuario}
                idSucursalUsuario={this.idSucursal(this.props)}
                onChangeContacto={this.onChangeContacto} 
                filtrarDireccionesPermiso={!this.props.documentarCualquierOrigen}
                contactoDestino={this.props.value.IdContactoOrigen}
            />,
            value.IdDireccionOrigen != null && <Sucursal key={2} field="IdSucursalOrigen" filtro={{ IdDireccionCliente: value.IdDireccionOrigen }} onChange={this.onSucursalChange} label="Sucursal origen" />,
            <Text key={3} readonly field="TelefonoCliente" label="Teléfono cliente:" />,
        ];

    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/origensucursal.tsx